/* eslint-disable */
import { useSeoFetch } from '@/hooks/useSeoFetch';
import seoAhrefsService from '@/services/seoAhrefs';

export function useKeywordDifficulty(keywords: string[], country = 'us') {
  const {
    data = [],
    isLoading,
    refetch,
  } = useSeoFetch(
    ['ahrefs-kd', ...keywords, country],
    () => seoAhrefsService.getKeywordDifficulty(keywords, country),
    { enabled: keywords.length > 0 }
  );

  // Build a lookup map for easy access: keyword -> difficulty data
  const difficultyMap = new Map(data.map((d) => [d.keyword, d]));

  return { difficultyData: data, difficultyMap, isLoading, refetch };
}

export function useCompetitors(projectId: string | undefined) {
  const {
    data: competitors = [],
    isLoading,
    refetch,
  } = useSeoFetch(
    ['ahrefs-competitors', projectId],
    () => seoAhrefsService.getCompetitors(projectId!),
    { enabled: !!projectId }
  );

  return { competitors, isLoading, refetch };
}

export function useKeywordGaps(projectId: string | undefined, page = 1, take = 50) {
  const { data, isLoading, refetch } = useSeoFetch(
    ['ahrefs-keyword-gaps', projectId, page, take],
    () => seoAhrefsService.getKeywordGaps(projectId!, { page, take }),
    { enabled: !!projectId }
  );

  return {
    gaps: data?.data ?? [],
    count: data?.count ?? 0,
    lastPage: data?.lastPage ?? 1,
    isLoading,
    refetch,
  };
}
